import React from "react";
import { Button } from "primereact/button";
import Title from "./Title";
import { INSTAGRAM_APP_LINK, INSTAGRAM_LINK } from "../constants/constants";
import { Link } from "react-router-dom";
import { isMobileUserAgent } from "../helpers/helpers";

function BuyBlock({
    containerClassNames = "text-white",
    buttonClassNames = "bg-custom-yellow active:bg-[#ffc400a9]",
    buttonTextClassNames = "text-darkgray",
}) {
    return (
        <div
            className={`flex flex-col ${containerClassNames} items-center px-6`}
        >
            <div className="w-fit flex flex-col text-center">
                <Title
                    classNames="lg:text-7xl"
                    title={"Сподобалась колекція?"}
                />

                <span className="text-lg lg:text-[35px] mt-4">
                    Дивіться каталог, там ще
                </span>
                <span className="text-lg lg:text-[35px] lg:mt-4">
                    багато різних цікавинок!
                </span>
            </div>

            <div className="w-full flex justify-center">
                <Link
                    className="w-full lg:w-fit px-4"
                    target="blank"
                    to={
                        isMobileUserAgent()
                            ? INSTAGRAM_APP_LINK
                            : INSTAGRAM_LINK
                    }
                >
                    <Button
                        className={`${buttonClassNames} shadow-none w-full lg:w-fit rounded-xl mt-6 lg:mt-[50px] py-2 lg:py-6 px-6 lg:px-[240px]`}
                    >
                        <span
                            className={`text-center buy-button w-full leading-[36px] xl:leading-[65px] text-4xl xl:text-[65px] font-extralight ${buttonTextClassNames} uppercase`}
                        >
                            Каталог
                        </span>
                    </Button>
                </Link>
            </div>
        </div>
    );
}

export default BuyBlock;
